import styled from 'styled-components';
import AppCSS from '../../../../utils/styled';
import { ReactComponent as CheckIcon } from '../../../../assets/icons/icon-check-alt.svg';
import { MENU_ITEM_HEIGHT } from '../../../../utils/styled/dimensions';
import { DropdownSelectableItemType } from '../../types';

export const Components = {
  Container: styled.div<{ isSelected: boolean; overrideItemType?: DropdownSelectableItemType; disableClick?: boolean }>`
    width: 100%;
    display: flex;
    padding: 12px 16px;
    max-height: ${MENU_ITEM_HEIGHT}px;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    ${({ isSelected }) => isSelected && `background-color: ${AppCSS.colors.greys.light};`};
    border-bottom: 1px solid ${AppCSS.colors.greys.light};
    ${({ disableClick }) => !disableClick && 'cursor: pointer;'}
    color: ${({ overrideItemType }) =>
      overrideItemType == 'disabled' || overrideItemType == 'disabledComingSoon'
        ? AppCSS.colors.black
        : AppCSS.colors.black};
  `,
  Title: styled.span<{ isSelected: boolean }>`
    ${({ isSelected }) => (isSelected ? AppCSS.fonts.label12Bold : AppCSS.fonts.label12Regular)};
  `,
  IconWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
  `,
  Icon: styled(CheckIcon)`
    width: 16px;
    height: 16px;
  `,
  ComingSoonLabel: styled.span`
    ${AppCSS.fonts.label10Regular};
    text-transform: uppercase;
  `,
};
